import {
  Input,
  Textarea,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@ncoder/ui";

interface RequestToolFormProps {
  form: {
    toolName: string;
    description: string;
    importance: string;
    useCase: string;
  };
  onChange: (key: string, value: string) => void;
}

export const RequestToolForm: React.FC<RequestToolFormProps> = ({
  form,
  onChange,
}) => (
  <div className="space-y-4 py-4">
    <div className="space-y-2">
      <Label htmlFor="toolName">Tool Name *</Label>
      <Input
        id="toolName"
        placeholder="e.g., Custom Objects to Lightning"
        value={form.toolName}
        onChange={(e) => onChange("toolName", e.target.value)}
      />
    </div>

    <div className="space-y-2">
      <Label htmlFor="description">Description *</Label>
      <Textarea
        id="description"
        placeholder="Describe what this tool should do and what it should modernize..."
        value={form.description}
        onChange={(e) => onChange("description", e.target.value)}
        rows={3}
      />
    </div>

    <div className="space-y-2">
      <Label htmlFor="importance">Importance *</Label>
      <Select
        value={form.importance}
        onValueChange={(value) => onChange("importance", value)}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select importance level" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="low">Low - Nice to have</SelectItem>
          <SelectItem value="medium">
            Medium - Important for efficiency
          </SelectItem>
          <SelectItem value="high">High - Critical for business</SelectItem>
          <SelectItem value="urgent">Urgent - Blocking current work</SelectItem>
        </SelectContent>
      </Select>
    </div>

    <div className="space-y-2">
      <Label htmlFor="useCase">Use Case (Optional)</Label>
      <Textarea
        id="useCase"
        placeholder="Describe your specific use case or scenario..."
        value={form.useCase}
        onChange={(e) => onChange("useCase", e.target.value)}
        rows={2}
      />
    </div>
  </div>
);
